import isPropValid from '@emotion/is-prop-valid';

const forwardedPropWhitelist = new Set(['as', 'forwardedAs']);

export const shouldForwardStyledProp = (
  propName: string,
  target: unknown,
) => {
  if (forwardedPropWhitelist.has(propName)) {
    return true;
  }

  if (typeof target === 'string') {
    return isPropValid(propName);
  }

  return true;
};
